<template>
  <div>
    <sc-form autocomplete="off" ref="contactForm">
      <template slot="fields" slot-scope="{ fields }">
        <div class="mainContent">
          <div v-if="!isEdit" class="mainContent__paragraphs">
            <p>
              Nessa etapa, você precisará configurar os REIDs (remetente IDs)
              que são obtidos com a Total Express. Para cada centro de
              distribuição e tipo de serviço contratado com a Total Express,
              preencha o REID correspondente.
            </p>
          </div>

          <div class="mainContent__reidTable">
            <div
              v-for="(row, index) of remetente_id_mapping"
              :key="index"
              class="mainContent__reidRow"
            >
              <sc-field
                label="Centro de Distribuição"
                :type="getFieldType(row, row.cnpj_warehouse)"
                :message="getMessage(row, row.cnpj_warehouse)"
              >
                <sc-select
                  class="span__select"
                  v-model="row.cnpj_warehouse"
                  @input="refreshRow(row)"
                >
                  <option
                    v-for="(warehouse, index) of warehouses"
                    :key="index"
                    :value="warehouse.federal_tax_payer_id"
                  >
                    {{ warehouse.name }}
                  </option>
                </sc-select>
              </sc-field>

              <sc-field label="CNPJ do centro de distribuição">
                <sc-input
                  :disabled="true"
                  :value="row.cnpj_warehouse"
                ></sc-input>
              </sc-field>

              <sc-field
                label="Tipo de Serviço"
                :type="getFieldType(row, row.service_type)"
                :message="getMessage(row, row.service_type)"
              >
                <sc-select
                  class="span__select"
                  v-model="row.service_type"
                  @input="refreshRow(row)"
                >
                  <option
                    v-for="(serviceType, index) of servicesTypes"
                    :key="index"
                    :value="serviceType.value"
                  >
                    {{ serviceType.label }}
                  </option>
                </sc-select>
              </sc-field>

              <sc-field
                label="remetente ID"
                :type="row.remetente_id == '' ? 'is-danger' : ''"
                :message="row.remetente_id == '' ? 'O campo é obrigatório' : ''"
              >
                <sc-input
                  v-model="row.remetente_id"
                  @input="refreshForm()"
                ></sc-input>
              </sc-field>

              <sc-button
                class="removeButton"
                @click="removeRow(index)"
                :disabled="remetente_id_mapping.length == 1"
                >X</sc-button
              >
            </div>
          </div>
          <sc-button @click="addRow">Adicionar</sc-button>
        </div>
      </template>

      <template slot="actions" slot-scope="{ isValid }">

        <div v-if="isEdit" class="editButtons">
          <sc-button
          class="startIntegration"
          text="Cancelar"
          theme="primary"
          />

          <sc-button
          class="startIntegration"
          text="Salvar"
          theme="primary"
          />
        </div>

        <div v-else>
          <sc-button
            text="Voltar"
            theme="default"
            type="button"
            @click="backStep()"
          />
          <sc-button
            text="Próximo"
            theme="primary"
            @click="navigateNext()"
            type="button"
          />
        </div>

      </template>
    </sc-form>
  </div>
</template>
  
<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScForm,
  ScField,
  ScSelect,
  ScInput,
  ScToast,
} from '@intelipost-js/secure-components';
import HelpButton from '../help-button/HelpButton.vue';

const { mapMutations, mapActions } = createNamespacedHelpers(
  'integrations/integrationsStep',
);

export default {
  name: 'sc-reids',
  props: {
    isEdit: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      remetente_id_mapping: [{}],
      warehouses: [{}],
      servicesTypes: [
        {
          value: '1',
          label: '1 - Expresso',
        },
        {
          value: '6',
          label: '6 - Standard',
        },
      ],
    };
  },
  created() {
    this.getWarehouses().then((response) => {
      this.warehouses = response;
    });
  },
  methods: {
    ...mapMutations(['nextStep', 'backStep', 'setAppConfigV2']),
    ...mapActions(['getWarehouses']),

    addRow() {
      this.remetente_id_mapping.push({});
    },

    removeRow(index) {
      this.refreshRow(this.remetente_id_mapping[index]);
      this.remetente_id_mapping = this.remetente_id_mapping.filter(
        (row, i) => i !== index,
      );
    },

    navigateNext() {
      if (this.hasEmptyField()) {
        return;
      }
      if (this.hasDuplicates()) {
        return;
      }

      this.saveInAppConfig();

      this.nextStep();
    },

    hasEmptyField() {
      if (
        !this.remetente_id_mapping.find(
          row => !row.cnpj_warehouse || !row.service_type || !row.remetente_id,
        )
      ) {
        return false;
      }
      this.remetente_id_mapping.forEach((row) => {
        if (!row.cnpj_warehouse) {
          row.cnpj_warehouse = '';
        }
        if (!row.service_type) {
          row.service_type = '';
        }
        if (!row.remetente_id) {
          row.remetente_id = '';
        }
      });
      this.refreshForm();
      return true;
    },

    hasDuplicates() {
      this.remetente_id_mapping.forEach(row => delete row.duplicated);
      let found = false;


      this.remetente_id_mapping.forEach((row1, index1) => {
        this.remetente_id_mapping.forEach((row2, index2) => {
          if (
            index2 > index1 &&
            row1.cnpj_warehouse === row2.cnpj_warehouse &&
            row1.service_type === row2.service_type
          ) {
            row1.duplicated = row2;
            row2.duplicated = row1;
            found = true;
          }
        });
      });

      if (found) {
        this.refreshForm();
      }
      return found;
    },

    saveInAppConfig() {
      this.setAppConfigV2({
        remetente_id_mapping: this.remetente_id_mapping,
      });
    },

    refreshRow(row) {
      if (row.duplicated) {
        const otherRow = row.duplicated;
        delete row.duplicated;
        delete otherRow.duplicated;
      }
      this.refreshForm();
    },

    refreshForm() {
      this.remetente_id_mapping = [...this.remetente_id_mapping];
    },

    getMessage(row, field) {
      if (field === '') {
        return 'O campo é obrigatório';
      }
      if (row.duplicated) {
        return 'Configuração duplicada';
      }
      return '';
    },

    getFieldType(row, field) {
      if (field === '' || row.duplicated) {
        return 'is-danger';
      }
      return '';
    },
  },

  components: {
    ScButton,
    ScForm,
    HelpButton,
    ScField,
    ScSelect,
    ScInput,
    ScToast,
  },
};
</script>
  
<style lang='scss' scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 40px;

  &__paragraphs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__reidTable {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__reidRow {
    display: flex;
    gap: 20px;
    height: 90px;
  }
}

.removeButton {
  align-self: center;
}
</style>
  


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-reids/ScReids.vue?9e35053e